import { metaResolver } from "resolvers";

const acceptInvitationPageResolver = (data) => {
  return {
    meta: metaResolver(data.meta),
  };
};

export default acceptInvitationPageResolver;
